import script from "./Graphs.vue?vue&type=script&setup=true&lang=js"
export * from "./Graphs.vue?vue&type=script&setup=true&lang=js"

import "./Graphs.vue?vue&type=style&index=0&id=e8c22cc2&lang=css"

const __exports__ = script;

export default __exports__